import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Network/Remote_Access/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import RemoteTable from 'components/Web_User_Interface/1440p_Series/Network/Remote_Access/remoteTable';
import DangerBox from 'components/Web_User_Interface/1440p_Series/Network/Remote_Access/DangerBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Netzwerk Menu // Fernzugriff",
  "path": "/Web_User_Interface/1440p_Serie/Netzwerk/Fernzugriff/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Sie haben zwei Möglichkeiten Ihre Kamera über das Internet zu erreichen - der einfache Weg ist P2P. Der einzige Weg um einen kompletten Zugriff auf Ihre Kamerafunktionen zu erhalten heißt DDNS. Die DDNS oder Internet Adresse gibt Ihnen Zugriff auf die Weboberfläche Ihrer Kamera.",
  "image": "./WebUI_1440p_SearchThumb_Network_Remote_Access.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Network_Remote_Access.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='Netzwerk Menü // Fernzugriff' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Sie haben zwei Möglichkeiten Ihre Kamera über das Internet zu erreichen - der einfache Weg ist P2P. Der einzige Weg um einen kompletten Zugriff auf Ihre Kamerafunktionen zu erhalten heißt DDNS. Die DDNS oder Internet Adresse gibt Ihnen Zugriff auf die Weboberfläche Ihrer Kamera.' image='/images/Search/WebUI_1440p_SearchThumb_Network_Remote_Access.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Network_Remote_Access.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Network/Remote_Access/' locationFR='/fr/Web_User_Interface/1440p_Series/Network/Remote_Access/' crumbLabel="Remote Access" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "netzwerk-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#netzwerk-men%C3%BC",
        "aria-label": "netzwerk menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Netzwerk Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "verbindung-über-das-internet",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#verbindung-%C3%BCber-das-internet",
        "aria-label": "verbindung über das internet permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Verbindung über das Internet`}</h3>
    <p>{`Ihre Kamera verfügt über eine persönliche `}<a parentName="p" {...{
        "href": "/de/Fernzugriff/Der_DDNS_Dienst/"
      }}>{`DDNS Adresse`}</a>{` - z.B. `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`http://xxxx77.ddns-instar.de`}</code>{`. Sie brauchen nur eine `}<a parentName="p" {...{
        "href": "/de/Fernzugriff/Port_Weiterleitung/"
      }}>{`Portweiterleitung`}</a>{` in Ihrem Router anzulegen, um die Kamera über das Internet zu erreichen. Sie können danach die DDNS Adresse in Ihren Browser eingeben und die Weboberfläche laden. Der Zugriff ist alternativ auch über unsere iPhone, iPad, Android, Blackberry und Windows Phone App möglich. Bitte besuchen Sie den Abschnitt über den `}<a parentName="p" {...{
        "href": "/de/Fernzugriff/Der_DDNS_Dienst/"
      }}>{`DDNS Dienst`}</a>{` für detaillierte Informationen zur `}<a parentName="p" {...{
        "href": "/de/Fernzugriff/Port_Weiterleitung/"
      }}>{`Portweiterleitung`}</a>{` und Beispiele für viele Router Modelle. Alternativ können Sie einmal einen Blick auf `}<a parentName="p" {...{
        "href": "https://portforward.com/router.htm"
      }}>{`portforward.com (externe Seite | Englisch)`}</a>{` werfen.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/e7fb1efa4a8423fce257632e63616b28/e2e58/1440p_Settings_Network_Remote_Access.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "53.043478260869556%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACY0lEQVQoz12RS08TURiG+xdcaGIDMWxkSm0wVCm9cWnp/Tb3mc5MW0HrDWmNEqAqiQgbE0ETNMaF7BQXxoWXxMS1P8GY+GceM9NaCYs37/edk/Oc7+ILhUIEhHEyV3epbn2msP6B9L33Ax0di/v54uAse/8dyvYX5DtPGfGfwe/3MzY2hm8iGEQQxsnbXcy1A9TuM5TOHmp3/79391CG3o/V7h72+kvKdoepi2EmJ8MEgyF8wWCQiYkJ5pNR8ukkuVSSSj5FdiFOMTNHJZcil0qQXUhQWJz17nILCRbnYuRScQrpHKp0nUK2SiQS7QMDAYF8oYjtNDHrlidNN2g0W+iGSd2yh9J1A0lWqIkSzaUl2vYyNytN5HKR6Mx0HygIAvl8nlarRaPRwLKsoWuahmkY6LqOPnBFUZBlGdUwadcVXnQU2stZZpMngI7jeBBX9Xrdkws0DKMPUFVM0/RyF1wTRTqrtzh8tUnLSBCbieBz5/cPaJh19JUn2Buv0Za6GJriteiCVVXpV2uaHsyFVspldnZ3+fP9E71WjUuXwydbbuI4DW+Wlu30QZrmAWRZQtN071MPrOtUq1Ue9zb49fUbb1bbRKanBksRBLLZHKrpIKqm98iy6sNWXUmShFSrIFdLiGKViqqQKpXY2Vzj988fHPZuYJUGWz4/LlApZDh6JPFxq0rnioyo6Oi65lXjVqkpMsbKNsaDt1xr9zgolXleErlrW+w/XOO2mKEwF+7PMBAIeCu3y0mccpz0bJSZaIxY7LiixFNFEnmV+fkcYiSCEkswGbzAqdOnOTsyysjoOf4C5jaxvFFAi+IAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/e7fb1efa4a8423fce257632e63616b28/e4706/1440p_Settings_Network_Remote_Access.avif 230w", "/de/static/e7fb1efa4a8423fce257632e63616b28/d1af7/1440p_Settings_Network_Remote_Access.avif 460w", "/de/static/e7fb1efa4a8423fce257632e63616b28/7f308/1440p_Settings_Network_Remote_Access.avif 920w", "/de/static/e7fb1efa4a8423fce257632e63616b28/c986f/1440p_Settings_Network_Remote_Access.avif 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/e7fb1efa4a8423fce257632e63616b28/a0b58/1440p_Settings_Network_Remote_Access.webp 230w", "/de/static/e7fb1efa4a8423fce257632e63616b28/bc10c/1440p_Settings_Network_Remote_Access.webp 460w", "/de/static/e7fb1efa4a8423fce257632e63616b28/966d8/1440p_Settings_Network_Remote_Access.webp 920w", "/de/static/e7fb1efa4a8423fce257632e63616b28/b8544/1440p_Settings_Network_Remote_Access.webp 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/e7fb1efa4a8423fce257632e63616b28/81c8e/1440p_Settings_Network_Remote_Access.png 230w", "/de/static/e7fb1efa4a8423fce257632e63616b28/08a84/1440p_Settings_Network_Remote_Access.png 460w", "/de/static/e7fb1efa4a8423fce257632e63616b28/c0255/1440p_Settings_Network_Remote_Access.png 920w", "/de/static/e7fb1efa4a8423fce257632e63616b28/e2e58/1440p_Settings_Network_Remote_Access.png 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/e7fb1efa4a8423fce257632e63616b28/c0255/1440p_Settings_Network_Remote_Access.png",
              "alt": "Web User Interface - 1440p Series - Network Remote Access",
              "title": "Web User Interface - 1440p Series - Network Remote Access",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <RemoteTable mdxType="RemoteTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <DangerBox mdxType="DangerBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <ul>
      <li parentName="ul">{`siehe auch:`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/Schnell_Installation/Internet_Protocol_IPv6/"
            }}>{`Was ist IPv6 und wie funktioniert SLAAC?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/Frequently_Asked_Question/WQHD_IPv6_Portforwarding/"
            }}>{`Anleitung zur IPv6 Portfreischaltung in einer AVM Fritzbox`}</a></li>
        </ul>
      </li>
    </ul>
    <p>{`Für den Fall, dass Sie einen Account von:`}</p>
    <ul>
      <li parentName="ul">
        <a href="http://dyn.com/dns/" target="_blank" rel="noopener noreferrer">dynDNS</a>
      </li>
      <li parentName="ul">
        <a href="https://www.noip.com/" target="_blank" rel="noopener noreferrer">NoIP</a>
      </li>
      <li parentName="ul">
        <a href="https://www.ddnss.de/" target="_blank" rel="noopener noreferrer">DDNSS</a>
      </li>
      <li parentName="ul">
        <a href="https://www.duckdns.org/" target="_blank" rel="noopener noreferrer">Duck DNS</a>
      </li>
    </ul>
    <p>{`nutzen möchten, wählen Sie einfach den Drittanbieter Dienst aus und geben Sie Ihr persönliches Login ein. Dadurch wird automatisch der der INSTAR DDNS Dienst deaktiviert - nach der nächsten WAN IP Adressänderung ist Ihre Kamera dann nicht mehr über die INSTAR DDNS Adresse erreichbar (die WAN IP Adresse ändert sich meistens alle 24h - Sie können Ihre WAN IP über den Dienst auf `}<a parentName="p" {...{
        "href": "https://www.wieistmeineip.de/"
      }}>{`wieistmeineip.de (externe Seite | Deutsch)`}</a>{` abrufen).`}</p>
    <p>{`Wenn Sie mehrere Kameras hinter einem Internetanschluss betreiben, hinterlegen Sie Ihre Drittanbieter DDNS Adresse bitte nur in einer Kamera. Alternativ können Sie die Drittanbieter DDNS Adresse natürlich auch direkt in Ihrem Router hinterlegen und darüber alle Kameras in dem Netzwerk erreichen! Sie brauchen nur jeder Kamera, in der Portweiterleitung einen, eigenen Port zuweisen. Wenn Ihrer Kamera 1 z.B. über den Port 8081 erreichbar ist und die Kamera 2 über den Port 8082, dann ist Kamera 1 über das Internet über myaddress.dyndns.org:8081 erreichbar und Kamera 2 über myaddress.dyndns.org:8082. Entsprechend können Sie natürlich auch nur eine INSTAR DDNS Adresse verwenden um alle Kameras im gleichen Netzwerk zu erreichen.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      